import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/card";
import constant from "../../../utils/constant";

const HUMAN_ROLES = `
	human_roles (q: $query, type_id: $type_id, for: $for, object_id: $object_id, object_type: $object_type) {
		id
		name
		type
	}`;

export default {
	init() {},

	fetchHumanRoles(payload) {
		const queryOptions = {
			query: gql`query HumanRoles ($query: String!, $type_id: Int, $for: String, $object_id: Int, $object_type: String) {
					${HUMAN_ROLES}
				}

			`,
			variables: {
				query: payload.query,
				object_id: payload.object_id,
				type_id: payload.type_id || 0,
				object_type: payload.object_type,
				for: payload.for || constant.HUMAN_ROLES_FOR.PEOPLE
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				humanRoles: response.data.human_roles
			};
		});
	}
};
